import { CmsContentElement } from "../cmscontent.types";
import * as CmsContentElements_Class from "./class";
import * as CmsContentElements_Named from "./named";
import * as CmsContentElements_Shortcode from "./shortcode";

export const CmsContentElementMap = new Map<CmsContentElement[0], CmsContentElement[1]>([
  ...Object.values(CmsContentElements_Class),
  ...Object.values(CmsContentElements_Named),
  ...Object.values(CmsContentElements_Shortcode),
]);
